<!-- 线上基础类别 -->
<template>
  <div class="">
    <!-- 搜索部分 -->
    <div class="">
      <el-form ref="productForm" :model="search_data" :inline="true" label-width="100px" label-position="right"
        size="medium" class="dyh-line-group el-form-class" style="">
        <el-form-item label="商品分类：" prop="classify_no">
          <el-select clearable  v-model="search_data.classify_no" placeholder="请选择分类" @change="SClassifyChange">
            <el-option v-for="item in classTreeList" :key="item.class_no" :label="item.class_name"
              :value="item.class_no">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="分类状态：" prop="classify_no">
          <el-select v-model="search_data.class_type" placeholder="请选择分类状态" @change="STypeChange">
            <el-option v-for="item in classTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="分类名称：" prop="classify_no">
          <el-input v-model="search_data.classify_name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item prop="classify_no" style="margin-left: 20px;">
          <el-button type="primary" @click="filterByClassName" plain>查询</el-button>
        </el-form-item>
        <el-form-item prop="classify_no" style="margin-left: 20px;">
          <el-button type="primary" @click="createClass">新建类别</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格部分 -->
    <div class="dyh-body-group" style="height: calc(100% - 100px);">
      <el-table :row-class-name="tableRowClassName" :data="filteredClassList"
        :header-cell-style="{ background: '#D9ECFF', color: '#333' }" :height="scroll_height"
        style="width: 100%;margin-bottom: 20px;" row-key="class_no"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <!-- <el-table-column label="行号" type="index" align="center" width="100">
        </el-table-column> -->
        <el-table-column prop="class_no" align="left" label="类别编号" width="300">
        </el-table-column>
        <el-table-column prop="class_name" align="center" label="类别名称" width="300">
        </el-table-column>
        <el-table-column prop="image" align="center" label="类别图标" width="300">
          <template slot-scope="scope">
            <el-image :src="scope.row.url" :preview-src-list="view_url" style="width: 40px; height: 40px;"
              fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column :formatter="standardFormatter" prop="standard_class_no" align="center" label="关联类别"
          width="200">
        </el-table-column>
        <el-table-column prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <div class="primary-flex-colum " style="justify-content: center;align-items: center;">
              <el-button type="text" size="mini" @click="updateClass(scope.row)">修改</el-button>
              <el-button type="text reda-text" size="mini" style="margin: 0px;"
                @click="deleteClass(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 模态框部分 -->
    <el-dialog :title="classTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px"
      :before-close="handleClose">
      <classify ref="classifyRef" @classDialogCancel="classDialogCancel"></classify>
    </el-dialog>
    <div class="empty-block"></div>
  </div>
</template>
<script>
import { getClassifyList, basicDownLoadImg } from '@/api/basic.js';
//import { offlineGenerateClass } from "@/api/offlinestores.js";
import { onlinesGetClassifyList, onlinesClassifyDelete } from '@/api/onlines/goods';
import { showDialog } from '@/js/public';
import classify from "../components/classify.vue";
export default {
  name: "onlinebaseclassinfo",
  components: {
    classify
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 190;
        }
      },
      deep: true,
      immediate: true
    },
    "class_data.parent_no": {
      handler(np, op) {
        this.spClassNo(np);
        this.my_self = np;
      }
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  data() {
    return {
      view_url: [],
      dialogVisible: false,
      search_data: { //搜索部分
        class_type: "",
        classify_no: "",
        classify_name: ""
      },
      allPrimaryClassList: [], //所有系统分类
      classTreeList: [], //分类状态
      classTypeOptions: [
        { value: 'active', label: '激活' },
        { value: 'inactive', label: '未激活' }
      ],
      filteredClassList: [],
      scroll_height: "",
      classTitle: "新建类别",
      my_self: "",
      class_data: {
        classify_no: "",
        classify_name: ""
      }
    };
  },
  /* eslint-disabled */
  async mounted() {
    this.getClassifyList();
    this.getSystemClassifyList();
  },
  methods: {
    SClassifyChange(e) {
      if (!this.search_data.classify_no) {
        // 如果分类编号为空，显示所有分类
        this.filteredClassList = [...this.classTreeList];
      } else {
        // 根据分类编号过滤
        this.filteredClassList = this.classTreeList.filter(item =>
          item.class_no && item.class_no.trim() === this.search_data.classify_no.trim()
        );
      }
    },
    filterByClassName() {
      if (!this.search_data.classify_name) {
        // 如果分类名称为空，显示所有分类
        this.filteredClassList = [...this.classTreeList];
      } else {
        // 根据分类名称过滤（模糊搜索）
        const searchName = this.search_data.classify_name.trim().toLowerCase();
        this.filteredClassList = this.classTreeList.filter(item =>
          item.class_name && item.class_name.toLowerCase().includes(searchName)
        );
      }
    },
    STypeChange(e) {
      console.log(e);
      if (e === "active") {

      } else {

      }
    },
    /**
     * 排序
     */
    orderByClassNo() {
      this.filteredClassList.sort((a, b) => {
        return Number(a.class_no) - Number(b.class_no);
      });
    },
    /**
     * 过滤器
     */
    standardFormatter(row) {
      return this.allPrimaryClassList.find(item => item.class_no.trim() === row.standard_class_no.trim())?.class_name || "";
    },
    /**
     * 类别对话框取消事件
     */
    classDialogCancel(e) {
      if (e) {
        this.getClassifyList();
      }
      this.handleClose();
    },
    /**
     * 新建类别
     */
    createClass() {
      this.dialogVisible = true;
      this.classTitle = "新建类别";
      setTimeout(() => {
        this.$refs.classifyRef.handleReset();
      }, 100);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    /**
     * 修改类别
     * @param row 选择的行
     */
    updateClass(row) {
      const that = this;
      this.classTitle = "修改类别";
      this.dialogVisible = true;
      console.log("选择的行数据", row);
      setTimeout(() => {
        that.$refs.classifyRef.setFormData(row);
      }, 100);
    },
    /**
     * 删除类别
     * @param row
     */
    async deleteClass(row) {
      if (await showDialog("删除类别", "确定要删除该类别吗？")) {
        const res = await onlinesClassifyDelete(row.class_no);
        if (res.state === true) {
          this.successMessage("类别删除成功");
          this.classTreeList = this.classTreeList.filter(item => item.class_no.trim() !== row.class_no.trim());
          this.filteredClassList = this.chassTreeList;
        }
      }
    },
    /**
     * 设置行样式
     */
    tableRowClassName({ row, rowIndex }) {
      /* if (rowIndex % 2 === 1) {
        return 'warning-row';
      } */
      return '';
    },
    /**
     * 获取所有线上类别
     */
    async getClassifyList() {
      const res = await onlinesGetClassifyList();

      this.classTreeList = res;
      console.log("线上类别列表", JSON.stringify(this.classTreeList));

      this.getClassifyUrl();
      this.orderByClassNo();
    },
    getClassifyUrl() {
      this.classTreeList.forEach(async item => {
        if (item.image.length === 64 && item.image.indexOf("http") === -1) {
          this.$set(item, "url", await this.mediaNoGetUrl(item.image));
        } else {
          this.$set(item, "url", item.image);
        }
      })
      this.filteredClassList = this.classTreeList;
    },
    /**
     * 通过media_no下载图片
     * @param {string} media_no 64位字符串
     */
    async mediaNoGetUrl(media_no) {
      let url = "data:image/png;base64," + (await basicDownLoadImg(media_no));
      this.view_url.push(url);
      return url;

      /* const res = await basicDownLoadImg(media_no);
      console.log("res----------------", res); */
      /* let url = ;
      console.log(url); */
    },
    /**
     * 获取所有系统分类
     */
    async getSystemClassifyList() {
      const res = await getClassifyList();
      console.log("系统分类列表", res);
      this.allPrimaryClassList = res.allList;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-table .warning-row {
  background: #ECF5FF !important;
}

.class-table-header {
  background-color: red;
}

.el-form-item {
  margin-bottom: 0px !important;
}

.el-form-class {
  height: 80px;
  justify-content: left;
  padding-left: 20px;
}

.class-lf {
  padding-left: 30px;
}

.class-fa {
  width: 100%;
  height: 100%;
  display: flex;
}

.l-title {
  height: 40px;
  font-size: 20px;
  line-height: 2;
  padding: 0 0 10px 20px;
}

.r-body {
  width: calc(100% - 500px);
}

.card-right {
  width: auto;
  max-width: 600px;
  height: auto;
  /* background: rgb(205, 230, 255); */
  padding: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
